import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import DoctorCard from '../../shared/DoctorCard';
import {
  APPLICATION_ID, authFeatureConstants, DEFAULT_GUID, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS, StatusFilterType,
  TOOLTIP_TEXT,
} from '../../../../shared/constants/commonConstants';
import { Button, Col, Input, Row, Select, Tooltip } from 'antd';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import { useHistory } from 'react-router-dom';
import { base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl } from '../../../../utils/utility';
import { DoctorDepartments, DoctorDetails, FetchDoctorsRequestPayload } from './../../../../shared/models/inventory.model';
import { useSelector, useDispatch } from 'react-redux';
import { FetchFileByteRequest } from '../../../../shared/models/file.profile.model';
import { fetchDoctorsImages, fetchDoctorsList, saveDoctorsList } from './../../../../store/actions/inventoryAction';
import { FileByteDetail } from './../../../../shared/models/file.profile.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { DOCTORS_DEPARTMENTS, FETCH_INVENTORY_DASHBOARD } from '../../../../shared/constants/urlEndPoints';
import Masonry from 'react-masonry-css';
import _ from 'lodash';
import NoDataFound from './../../shared/NoDataFound';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { dashBoardRequest } from '../../../../store/actions/leftSideBarAction';
import { ReactComponent as ClearAll } from '../../../../assets/images/svg/i_close_red.svg';
import DoctorCardLoader from './DoctorCardLoader';

const DoctorsList = ({ match: { path } }: any): ReactElement => {
  const { Option } = Select;
  let timeout: any;
  const history = useHistory();
  const [departments, setDepartments] = useState(null as any);
  const dispatch = useDispatch();
  const [doctorList, setDoctorList] = useState(null as any);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [refreshStore, setRefreshStore] = useState(true);
  const [statusType, setStatusType] = useState(undefined as any);
  const [drInput, setDrInput] = useState(undefined as any);
  const [isImage, setIsImage] = useState(false);
  const [isDefault, setIsDefault] = useState(true);
  const [filterOption, setFilterOption] = useState([] as any);
  const [departmentIds, setDepartmentIds] = useState([] as any);
  const doctorsDetailList = useSelector(({ inventory: { doctorsList } }: any): DoctorDetails[] | any => doctorsList);
  const doctorsImage = useSelector(({ inventory: { doctorsImages } }: any): FileByteDetail[] => doctorsImages);
  const dashboardPayload: any = {
    title: INVENTORY_MESSAGE_CONSTANTS.title.doctors,
    url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: INVENTROY_CONSTANTS.doctor,
  };
  useEffect((): void => {
    fetchDepartments();
  }, []);

  useEffect((): void => {
    if (doctorsDetailList && !doctorsDetailList.error) {
      const doctorsList = [...doctorsDetailList];
      doctorsList.forEach((v: DoctorDetails): any => v.isExpanded = false);
      setDoctorList(doctorsList);
      setIsImage(true);
      setDataLoaded(true);
    } else if (doctorsDetailList && doctorsDetailList.error) {
      setDoctorList(null);
      setDataLoaded(true);
    }
  }, [doctorsDetailList]);

  useEffect((): void => {
    if (doctorList && doctorList.length && !doctorsImage && refreshStore) {
      const fileGuids: string[] = doctorList.map((v: DoctorDetails | any): string => {
        return v?.personalDetail?.imageId !== DEFAULT_GUID ? v?.personalDetail?.imageId : null;
      }).filter((vv: any): boolean => vv);
      getDoctorsImages(fileGuids);
    }
  }, [doctorList]);

  useEffect((): void => {
    if (doctorsImage && doctorsImage.length && doctorList && doctorList.length && isImage) {
      const updatedDoctorList = [...doctorList]; // Copy the list
      updatedDoctorList.forEach((v: DoctorDetails | any): void => {
        const index = doctorsImage.findIndex((vv: FileByteDetail | any): boolean => vv.fileGuid === v?.personalDetail?.imageId);
        if (index !== -1) {
          v.imageUrl = doctorsImage[index].fileBytes;
        }
      });
      // Only update if the list has actually changed
      if (!_.isEqual(doctorList, updatedDoctorList)) {
        dispatch(saveDoctorsList(updatedDoctorList));
      }
      // Set this flag only once
      setIsImage(false);
    }
  }, [doctorsImage, doctorList]);

  useEffect((): void => {
    if (!isDefault) {
      getDoctorsList(true);
    } else {
      setIsDefault(false);
    }
  }, [departmentIds, statusType, drInput]);

  const getDoctorsImages = (fileIdentifiers: string[]): void => {
    const payload: FetchFileByteRequest = {
      applicationId: APPLICATION_ID,
      fileIdentifiers,
    };
    dispatch(fetchDoctorsImages(payload));
  };

  const fetchDepartments = async (): Promise<void> => {
    const departmentResponse = await SendRequest.instance.get(process.env.REACT_APP_INVENTORY_API_BASE_URL + DOCTORS_DEPARTMENTS);
    if (departmentResponse && departmentResponse.isSuccess && departmentResponse.packageDetails) {
      const dptmnt = [] as any;
      departmentResponse.packageDetails.map((i: any): any => {
        dptmnt.push({
          id: i.id,
          name: i.name,
          description: i.description,
          groupId: i.groupId,
          groupName: i.groupName,
          isActive: i.isActive,
          value: i.name,
        });
      });
      setDepartments(_.uniqBy(dptmnt, 'name'));
    } else if (departmentResponse && departmentResponse.errorMessage) {
      error(departmentResponse.errorMessage);
    } else {
      error(INVENTROY_CONSTANTS.noDataFound);
    }
  };

  const viewDoctorProfile = (doctorDetails?: any): void => {
    history.push(`${extractSecondLevelBaseUrl(path)}${doctorDetails ? `${INVENTROY_CONSTANTS.doctorProfileRoute}${base64UrlEncode(doctorDetails.id)}` : '/' + INVENTROY_CONSTANTS.newDoctorProfile}`);
    if (doctorDetails) {
      getDoctorsList(false);
    }
  };

  const onFilterProfile = async (v: any, type: string): Promise<any> => {
    setDataLoaded(false);
    const depIds: any = departments?.filter((vv: DoctorDepartments): boolean => {
      return type === INVENTROY_CONSTANTS.department ? v?.findIndex((c: string): boolean => c === vv.value) > -1 : false;
    }).map((vvv: DoctorDepartments): any => vvv.id) || [];
    setRefreshStore(true);
    if (type === INVENTROY_CONSTANTS.status) {
      setStatusType(v);
    } else {
      setFilterOption(v);
      setDepartmentIds(depIds);
    }
  };

  const getDoctorsList = (isPayload: boolean): any => {
    const payload: FetchDoctorsRequestPayload = {
      pageNumber: 1,
      pageSize: 100,
      doctorByProfileId: true,
      fetchInActiveRecord: true,
      doctorByName: drInput ? true : false,
      doctorName: drInput ? drInput : undefined,
      departmentIds: departmentIds && departmentIds.length ? departmentIds : undefined,
      doctorByDepartmentId: departmentIds && departmentIds.length ? true : false,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      statusType: statusType ? statusType : 'NA',
    };
    isPayload ? dispatch(fetchDoctorsList(payload)) : dispatch(fetchDoctorsList(null));
    dashboardPayload.filter = {
      departmentIds: payload?.departmentIds,
      name: payload?.doctorName,
      statusName: payload?.statusType,
    };
    dispatch(dashBoardRequest(dashboardPayload));
  };

  const onDoctorNameSearch = (e: any): any => {
    e.persist();
    clearTimeout(timeout);
    timeout = setTimeout(async (): Promise<void> => {
      setDataLoaded(false);
      setRefreshStore(true);
      setDrInput(e.target.value);
    }, 300);
  };

  const onCollapse = (doctor: DoctorDetails, isExpanded: boolean): any => {
    const drList = [...doctorList];
    drList.forEach((v: DoctorDetails): any => {
      if (v.id === doctor.id) {
        v.isExpanded = isExpanded;
      } else {
        v.isExpanded = false;
      }
    });
    setDoctorList(drList);
  };
  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().includes(inputValue.toUpperCase());
  };

  const onRefresh = (): void => {
    setDataLoaded(false);
    setRefreshStore(false);
  };

  const onClearAllFilters = (): void => {
    setRefreshStore(true);
    setFilterOption([]);
    setDepartmentIds([]);
    setStatusType(undefined);
    setDrInput('');
  };

  return (
    <>
      <PageHeader
        pageTitle="Doctor List"
        colSize={4}
        customeClass={'inv-page-header-align'}
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE} className="inv-page-header-align">
              <Col md={7}>
                <Select
                  mode={'multiple'}
                  className="w-100 scrollable-select mouse-pointer"
                  placeholder="Select departments"
                  optionLabelProp="label"
                  filterOption={onFilter}
                  value={filterOption}
                  allowClear={true}
                  onChange={(e: any): any => onFilterProfile(e, INVENTROY_CONSTANTS.department)}
                  options={departments}
                />
              </Col>
              <Col md={6} style={{ textAlign: 'left' }}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Select status"
                  value={statusType}
                  allowClear={statusType === '' ? false : true}
                  onChange={(e: any): any => onFilterProfile(e, INVENTROY_CONSTANTS.status)}
                >
                  <Option value={StatusFilterType.isApproved}>Verified</Option>
                  <Option value={StatusFilterType.isSubmit}>Pending</Option>
                  <Option value={StatusFilterType.isRejected}>Rejected</Option>
                </Select>
              </Col>
              <Col md={6}>
                <Input placeholder="Search Dr. name"
                  allowClear={true}
                  ref={(e: any): any => e && e.focus()}
                  defaultValue={drInput}
                  onChange={(e: any): void => onDoctorNameSearch(e)}
                />
              </Col>
              <Col md={1} style={{ marginTop: '6px' }}>
                {((departmentIds && departmentIds.length > 0) || (statusType) || (drInput)) &&
                  <Tooltip title={TOOLTIP_TEXT.clearAll}><ClearAll onClick={onClearAllFilters} /></Tooltip>
                }
              </Col>
              {
                canActivate(authFeatureConstants.EDIT_DOCTORS) &&
                <Col md={4}>
                  <div className="text-right"><Button onClick={(): void => viewDoctorProfile()} type="primary"> + Add Doctor</Button></div>
                </Col>
              }
            </Row>}
      />
      <div className="ant-tabs-content-holder tab-custom-container doctor-profile">
        <Masonry
          breakpointCols={INVENTROY_CONSTANTS.breakpointColumnsObj}
          className="doctor-masonry-grid width-size"
          columnClassName="doctor-masonry-grid_column">
          {doctorList && doctorList.length > 0 && doctorList.map((v: DoctorDetails, i: number): ReactNode => {
            return (
              <>
                <DoctorCard key={Date.now() + v.id}
                  onRefresh={onRefresh}
                  viewDoctorProfile={viewDoctorProfile} data={v} imgUrl={v.imageUrl} onCollapse={onCollapse} />
              </>
            );
          })}
        </Masonry>
        {(!doctorList && !dataLoaded) && <DoctorCardLoader />}
        {(!doctorList && dataLoaded) && <NoDataFound />}
      </div>
    </>
  );
};

export default DoctorsList;
